import axios from 'axios';
import { createAuthInterceptor } from './interceptors/authInterceptor';
import { isOidcAuth } from '../config/featureFlags';
import { userManager } from '../components/OidcAuthProvider';

// @ts-ignore - Runtime env from config.js
const runtimeUrl = window.ENV?.REACT_APP_API_BASE_DEV_URL;
const isTemplate =
  runtimeUrl && runtimeUrl.startsWith('${') && runtimeUrl.endsWith('}');
const baseURL =
  (isTemplate ? process.env.REACT_APP_API_BASE_DEV_URL : runtimeUrl) ||
  process.env.REACT_APP_API_BASE_DEV_URL;

const API = axios.create({
  baseURL,
  withCredentials: true
});

if (isOidcAuth()) {
  API.interceptors.request.use(async (config) => {
    const user = await userManager.getUser();
    if (user?.access_token) {
      config.headers = config.headers ?? {};
      config.headers['Authorization'] = 'Bearer ' + user.access_token;
    }
    return config;
  });
}

const authInterceptor = createAuthInterceptor(API);
API.interceptors.response.use(
  authInterceptor.response,
  authInterceptor.responseError
);

export default API;
